module.exports = __webpack_public_path__ + "static/img/ff698bb2d25c4d218b3256b46c706ece.e4ae292b.jpeg";